const pjson = require('../package.json')
export const APP_VERSION = pjson.version

export const DEFAULT_LANGUAGE = 'de'

export const NOT_AVAILABLE_LABEL = 'Blockseminare'

export const ERR_NO_CACHE_NETWORK = 1
export const ERR_NO_NETWORK = 2
export const ERR_NO_CACHE = 3
export const ERR_UNKNOWN = 99

export const CACHE_NAME = 'vvz-api-cache'
export const CACHED_HOME = 0
export const CACHED_SELECTOR = 1
export const CACHED_LECTURES = 2

export const CHANNEL_NAME = 'vvz-messages'
export const CHANNEL_MESSAGE = {
  refresh: false,
  error: false,
  code: 0,
  title: '',
  message: '',
}

export const PWA_PROMPT_KEY_NAME = 'installPromptedAt'
export const PWA_PROMPT_KEY_REFRESH_AFTER = 1  // days

export const RESET_ALL = 0
export const RESET_COURSE = 1
export const RESET_LECTURE = 2
export const RESET_SEMESTER = 3
export const RESET_STUDY_SEMESTER = 4

export const FACULTY_DESIGN_API_URL = 'https://fhp.incom.org/action/vlv-download-json/'
export const FACULTY_DESIGN_ID = 55
export const RESET_FACULTY_DESIGN_DATA = 5
export const RESET_FACULTY_DESIGN_SEGMENT = 6

export const FLEX_FACULTY = {
  id: 'FLEX',
  logo: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90"><g id="eb51988d-1ffd-4b24-97f5-5fe3d3b6038b" data-name="CTA Icons"><polygon points="90 0 75.23 0 44.987 30.15 14.727 0 0 0 0 14.769 30.115 44.977 0 75 0 90 15 90 44.992 59.899 75 90 90 90 90 75 59.864 44.973 90 14.727 90 0"/></g></svg>',
  notice: '',
  name: 'Fächer&shy;übergreifende Lehr&shy;veranstaltungen',
}

const ROUTES = {
  HOME: '/',
  SELECTOR: '/selector',
  LECTURES: '/lectures',
}

export const DEBUG_APP = false

const DEFAULTS = {
  ...ROUTES,
  // ... common settings
  ENABLE_MATOMO: false,
}

const prod = {
  ...DEFAULTS,
  // ... production specific
  ENABLE_MATOMO: true,
}

const dev = {
  ...DEFAULTS,
  // ... local dev specific
};

export const config = process.env.NODE_ENV === 'development' ? dev : prod;
